import { render, staticRenderFns } from "./DettaglioTipoAbbonamento.vue?vue&type=template&id=65ddec36&"
import script from "./DettaglioTipoAbbonamento.vue?vue&type=script&lang=js&"
export * from "./DettaglioTipoAbbonamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports